import { useModules, useTags, type AppModule } from '@entities/common';
import cn from 'classnames';
import { Calendar } from '@shared/assets';
import * as st from './styles.module.scss';

export const SectionList: React.FC = () => {
  const { eventModules, setModule, selectedModule } = useModules();
  const { resetSelectedTags } = useTags();

  const handleSectionClick = (module: AppModule) => {
    resetSelectedTags();
    setModule(module);
  };

  return (
    <ul className={st.list}>
      {eventModules?.map((section) => {
        const btnStateClass = selectedModule?.id === section.id ? st.list__item_active : st.default;

        return (
          <li
            className={cn(st.list__item, btnStateClass)}
            onClick={() => handleSectionClick(section)}
            key={section.id}
          >
            <span className={st.item__icon}>
              <Calendar />
            </span>
            <span>{section.verbose_name}</span>
          </li>
        );
      })}
    </ul>
  );
};
